<template>
  <div>
    <div class="row">
        <div class="sixty">
          <div class="envn" style="margin-left:10px">
                <h3>Hey there!</h3>
                <p>We should really have something more here...</p>
                <p>
                  <a :href="subscription.customer.url" class="button" v-if="isLoaded">Manage Your Subscription</a>
                </p>
          </div>
        </div>
        <div class="thirty" style="padding-top:40px; margin-left:auto; background-color:#fff">
          <div style="margin-left:20px">
          <h3>Account Summary</h3>
          <table>
            <tr v-if="org">
              <td>Oragnisation:</td>
              <td>{{ org.name }}</td>
            </tr>
            <tr v-if="org">
              <td>Account ID:</td>
              <td>{{ org.id | account }}</td>
            </tr>
            <tr>
              <td>My Account Plan:</td>
              <td>Basic Plan (Monthly)</td>
            </tr>
          </table>
          <div v-if="org">
            <!-- Need to get invite number -->
            <label for="contributors">{{ org.invites }} / 5 contributors:</label><br>
            <progress id="contributors" max="100" :value="invitePercentage"> {{ invitePercentage }}% </progress><br>
            <button @click="showInviteModal = true" v-if="org.invites < 5" style="margin-left:0">Invite a contributor</button>
          </div>
          </div>
        </div>
      </div>

      <div class="modal-mask" v-if="showSuccessModal">
        <div class="modal-wrapper">
          <div class="modal-container">

            <div class="modal-header">
              <svg viewBox="-260 -10 600 90" xmlns="http://www.w3.org/2000/svg"><path d="M71.301-.241H10.695C5.148-.241.606 4.3.606 9.848v60.587c0 5.547 4.542 10.089 10.089 10.089h60.588c5.547 0 10.088-4.542 10.088-10.089V9.848C81.389 4.3 76.847-.241 71.301-.241zm-35.348 62.67L17.23 43.723l7.144-7.145 11.579 11.579 24.199-24.199 7.145 7.145c-.018 0-31.344 31.326-31.344 31.326z" fill="#ffffff"/></svg>
                AWESOME!
            </div>

            <div class="modal-body">
                {{ account.name }} has been invited!
            </div>

            <div class="modal-footer">
                <span class="cancel" @click="showSuccessModal = false">We should awkwardly close this modal now...</span>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-mask" v-if="showInviteModal">
        <div class="modal-wrapper">
          <div class="modal-container">

            <div class="modal-header">
              <svg viewBox="-260 -10 600 90" xmlns="http://www.w3.org/2000/svg"><path d="M71.301-.241H10.695C5.148-.241.606 4.3.606 9.848v60.587c0 5.547 4.542 10.089 10.089 10.089h60.588c5.547 0 10.088-4.542 10.088-10.089V9.848C81.389 4.3 76.847-.241 71.301-.241zm-35.348 62.67L17.23 43.723l7.144-7.145 11.579 11.579 24.199-24.199 7.145 7.145c-.018 0-31.344 31.326-31.344 31.326z" fill="#ffffff"/></svg>
                INVITE SOMEONE!
            </div>

            <div class="modal-body">
              <progress-ring v-show="isSaving" radius="60" :progress="progress" stroke="4"></progress-ring>
              <form v-show="!isSaving" @submit.prevent="sendInvite">
              <p v-if="inviteErrors.length">
                <b>Please correct the following error(s):</b>
                <ul>
                  <li v-for="error in inviteErrors">{{ error }}</li>
                </ul>
              </p>
              <p>
              <label for="email">email</label>
              <input v-model="account.email" type="email" id="email" required>
              </p>
              <p>
              <label for="name">name</label>
              <input v-model="account.name" type="name" id="name" required>
              </p>
              <div class="row">
                <div class="fifty">
                  <span class="cancel" @click="showInviteModal = false">Cancel</span>
                </div>
                <div class="fifty">
                  <button type="submit">Invite</button>
                </div>
              </div>
            </form>
            </div>
            <div class="modal-footer">
                &nbsp;
            </div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
import { RepositoryFactory } from '@/services/repositoryfactory'
import ProgressRing from '@/components/progress-ring.vue'
const OrgRepository = RepositoryFactory.get('organisation');

export default {
  name: 'organisation',
  props: ['org'],
  components: {
    ProgressRing
  },
  data: () => ({
    isLoaded: false,
    progress: 0,
    subscription: null,
    isSaving: false,
    showSuccessModal: false,
    showInviteModal: false,
    inviteErrors: [],
    account: {
      name: '',
      email: ''
    }
  }),
  mounted() {
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch () {
      this.subscription = await OrgRepository.getSubscription();
      this.isLoaded = true;
    },
    async sendInvite(evt) {
      this.inviteErrors = [];

      if (!this.account.name || evt.target[1].validationMessage) {
        if(!this.account.name) {
          this.inviteErrors.push('Name required.');
        }

        if(evt.target[1].validationMessage) {
          this.inviteErrors.push(evt.target[1].validationMessage);
        }
        return false;
      }

      this.isSaving = true;

      const interval = setInterval(() => {
        this.progress += 1;
        if (this.progress === 100) {
          clearInterval(interval);
        }
      }, 100);

      var invited = await OrgRepository.invite(this.account);

      if(invited.success == 'Invite sent') {
        this.showInviteModal = false;
        this.showSuccessModal = true;
        this.org.invites += 1;
        this.account.name = "";
        this.account.email = "";
      } else {
        // @todo errorModal
      }

    }
  },
  computed: {
    invitePercentage() {
      var percent = this.org.invites / 5 * 100
      return percent;
    }
  },
  filters: {
    account: function (value) {
      if (!value) return ''
      return value.split("-")[0];
    }
  }
}

</script>

<style>
a.button {
  margin-left: 0;
  background-color: #ed4a65;
}
.modal-body form {
  padding: 0 40px;
  text-align: left;
}
</style>
